import React, { useContext } from 'react';
import { Context } from 'components/Store';
import GrowUIFormField from 'components/Forms/GrowUIFormField';
import { Select } from '@agconnections/grow-ui';

const Irrigated = () => {
  const [{ isEnableInfoTabEdit }] = useContext(Context);
  return (
    <GrowUIFormField
      control={Select}
      id="irrigated"
      name="irrigated"
      items={[
        { key: null, value: 'Select irrigation status' },
        { key: true, value: 'Yes' },
        { key: false, value: 'No' }
      ]}
      label="Irrigated"
      disabled={!isEnableInfoTabEdit}
      placeholder="Select irrigation status"
    />
  );
};

export default Irrigated;
